<template>
    <li>
        <loader
            v-if="loading"
        />
        <div v-else-if="!!report">
            <slot name="description">
                <report-description
                    :report="report"
                />
            </slot>
            <slot></slot>
            <slot name="stamp">
                <report-data-stamp
                    :report="report"
                    :versions="versions"
                    :loading="refreshing"
                    :export-url="exportUrl"
                    @refresh="$emit('reload')"
                    @load-version="$emit('load-version', $event)"
                />
            </slot>
        </div>
        <div v-else>
            <em>Unknown report....</em>
        </div>
    </li>
</template>

<script>
import Loader from "../../ui/Loader"
import ReportDescription from "./ReportDescription"
import ReportDataStamp from "./ReportDataStamp"

export default {
    components: {
        Loader,
        ReportDescription,
        ReportDataStamp
    },
    props: {
        report: {
            validator: prop => !prop || (typeof prop === "object"),
            required: true
        },
        versions: {
            type: Array,
            default () {
                return []
            }
        },
        loading: {
            type: Boolean,
            default: true
        },
        refreshing: {
            type: Boolean,
            default: false
        },
        exportUrl: {
            type: String,
            default: ""
        }
    }
}
</script>
